import { skTranslations } from "./sk";

export const translations = {
  cs: {
    nav: {
      home: "Domů",
      pillars: "Naše služby",
      instore: "Instore Data",
      admin: "Admin",
      contact: "Kontakt",
      about: "O nás",
    },
    common: {
      learnMore: "Zjistit více",
      comingSoon: "Připravujeme",
      backHome: "Zpět na úvod",
      czech: "CZ",
      slovak: "SK",
      english: "EN",
    },
    home: {
      eyebrow: "Budoucnost retailu / Future of retail",
      heroTitle: "Reálná data z prodejen. Reálná převaha v jednání.",
      heroSub:
        "Global Marketing je provozovatel vlastních systémů pro sběr a analýzu instore dat. Nepracujeme s odhady — pracujeme s fakty z terénu.",
      heroCta1: "Prozkoumat Instore Data",
      heroCta2: "Naše služby",
      headerCta: "Prozkoumat naše služby",
      pillarsEyebrow: "Šest pilířů / 6 Pillars",
      pillarsTitle: "Architektura moderního merchandisingu.",
      pillarsSub:
        "Šest vzájemně propojených oblastí, kterými pomáháme značkám rozhodovat se na základě dat — ne dojmů.",
      stats: [
        { k: "1 200+", v: "monitorovaných prodejen" },
        { k: "40 mil.+", v: "datových bodů ročně" },
        { k: "99,2 %", v: "dostupnost reportů" },
        { k: "24 h", v: "od auditu k dashboardu" },
      ],
      ctaTitle: "Připraveni na další krok?",
      ctaSub:
        "Pojďme si promluvit o vaší kategorii, prodejnách a kampaních. Nezávazně.",
      ctaButton: "Kontaktujte nás",
    },
    pillars: {
      merchandising: {
        title: "Merchandising Services",
        kicker: "01",
        desc: "Komplexní merchandising napříč CZ a SK. MERVIK + SYMES + AI report. Same-day řešení reklamací.",
      },
      instore: {
        title: "InStore Data",
        kicker: "02",
        desc: "Price & shelf monitoring v reálném čase. SYMES + QlikView. Fakta místo dojmů.",
      },
      shelfmasters: {
        title: "Shelfmasters",
        kicker: "03",
        desc: "Outsourcing retailové exekuce. SLA model místo FTE — −66 % nákladů, měřitelné KPI, žádný lock-in.",
      },
      digital: {
        title: "RetailStore Digitalisation",
        kicker: "04",
        desc: "Digitalizace prodejny — od ESL přes IoT senzory po in-store analytiku chování.",
      },
      consulting: {
        title: "Retail Consulting",
        kicker: "05",
        desc: "Go-to-Market, vyjednávání s řetězci, JBP, lidské zdroje a in-store data. 28+ let praxe.",
      },
      pos: {
        title: "POS",
        kicker: "06",
        desc: "Výroba, sklad, distribuce a instalace POS materiálů. POS E-shop pro obchodní týmy. Promokalendar pro retailery.",
      },
    },
    merchandising: {
      hero: {
        eyebrow: "Pilíř 01 / Merchandising",
        title: "Vaše produkty na správném místě. Vždy.",
        sub:
          "Merchandising je základ každé úspěšné přítomnosti v retailu. Nestačí produkt dostat na regál — je potřeba zajistit, aby tam byl ve správném množství, na správném místě a v souladu s plánogramem i nastavenými obchodními podmínkami. Každý den, v každé prodejně.",
        leadIn:
          "Global Marketing zajišťuje komplexní merchandisingové služby na celém území České republiky a Slovenska. Pokrýváme všechny obchodní řetězce i nezávislý trh — s vlastním týmem, systémy a reportingem.",
      },
      process: {
        eyebrow: "Jak merchandising funguje",
        title: "Terén, řízení a data v jednom systému.",
        intro:
          "Každá servisní návštěva je řízená, dokumentovaná a vyhodnocená. Proces servisní návštěvy probíhá v pěti krocích.",
        steps: [
          { n: "01", h: "Zadání servisu", t: "Kompletní zadání návštěvy přímo do mobilní aplikace MERVIK." },
          { n: "02", h: "Kontrola plochy", t: "Stav prodejní plochy, planogram, akční zóny a cenovky." },
          { n: "03", h: "Doplnění zboží", t: "Doplnění do všech pozic — primární regál i druhotná umístění." },
          { n: "04", h: "Reporting", t: "Záznam, fotodokumentace a strukturovaný report z místa." },
          { n: "05", h: "Synchronizace", t: "Data se okamžitě přenáší do reportingového systému SYMES." },
        ],
        outro: "Výsledky jsou přístupné okamžitě — bez čekání, bez ručního reportování.",
      },
      team: {
        eyebrow: "Náš tým",
        title: "Víte, kdo servisuje vaše prodejny. A proč na něm záleží.",
        intro: "Za každou zakázkou stojí konkrétní tým s jasně definovanými rolemi a odpovědnostmi.",
        roles: [
          {
            h: "Key Account Manager",
            kicker: "Hlavní kontakt",
            items: [
              "Hlavní kontakt pro klienta",
              "Řídí celou zakázku, komunikuje s obchodním týmem klienta",
              "Implementuje požadavky do praxe a odpovídá za výsledky",
            ],
          },
          {
            h: "Regionální manažeři",
            kicker: "Field leadership",
            items: [
              "Řídí terénní tým merchandiserů",
              "Zajišťují školení, náhrady, kontrolní činnost",
              "Přímá komunikace s obchodním týmem klienta",
            ],
          },
          {
            h: "Tým SYMES",
            kicker: "Data & reporting",
            items: [
              "Nastavuje podobu a frekvenci reportingových výstupů",
              "Spravuje listingy, zadává fotokampaně",
              "Kontroluje kvalitu dat",
            ],
          },
        ],
      },
      quality: {
        eyebrow: "Kontrola a kvalita servisu",
        title: "Každá návštěva je doložená. Každý problém je řešený.",
        body: [
          "Regionální manažeři provádějí pravidelné kontrolní návštěvy na základě předem definovaného měsíčního plánu. Fotodokumentace je pořizována výhradně online přímo z mobilní aplikace — bez fotografie nelze servisní návštěvu ukončit. Umožňujeme také klientské kontroly formou spolujízdy.",
          "Pokud nastane problém, řešíme ho ten samý den. Reklamaci zadáte online přímo do systému SYMES — a my ihned reagujeme. Náhradní návštěva, výměna merchandisera, eskalace na manažera. Žádné čekání na příští týden.",
        ],
        callouts: [
          { k: "100%", t: "návštěv s povinnou online fotodokumentací" },
          { k: "Same-day", t: "řešení reklamací přes SYMES" },
          { k: "Spolujízda", t: "klientské kontroly v terénu" },
        ],
      },
      reporting: {
        eyebrow: "Reporting a data",
        title: "Víte, co se děje na každé prodejně. V reálném čase.",
        intro:
          "Všechna data ze servisních návštěv jsou okamžitě dostupná v reportingových systémech ve čtyřech podobách.",
        items: [
          {
            n: "01",
            tag: "SYMES Online",
            h: "Komplexní online přehled 24/7",
            body:
              "Neomezený přístup ke kompletním informacím ze servisních návštěv s exportem do Excelu a fotodokumentací — kdykoli, odkudkoli.",
            list: [
              "Příznak položky: OK · OOS · STOP · NELIST · NÍZKÁ ZÁSOBA",
              "Cena",
              "Druhotná umístění (DU) na prodejně",
              "Dotazník (definuje klient — OOS, POS materiály)",
              "Textové pole pro poznámky",
              "Fotodokumentace každé návštěvy",
            ],
          },
          {
            n: "02",
            tag: "Email Summary",
            h: "Denní e-mailový přehled v 6:00",
            body:
              "Excel sumarizace za předchozí den zasílaná v 6:00 ráno na vámi definované adresy — OOS, ceny, kontrola listingu a další parametry dle vašeho nastavení.",
          },
          {
            n: "03",
            tag: "QlikView",
            h: "Grafická analytika světové třídy",
            body:
              "Asociativní analytika — OOS podle EAN, obchodního zástupce, regionu, řetězce nebo prodejny. Opakující se OOS a délka jejich trvání. Výstupní formáty PDF nebo živá licence.",
          },
          {
            n: "04",
            tag: "AI Report · NEW",
            h: "AI analýza fotografií z prodejny",
            body:
              "Absolutní novinkou je AI report. Data jsou reportována přímo z fotografií pořízených v prodejně — analyzujeme všechny položky na regále, cenovky, označení akční ceny a úroveň zaplněnosti regálu. Výstup ve formátu PDF.",
          },
        ],
        footer:
          "Zaškolení na straně klienta a příprava reportingových šablon naším programátorem jsou v ceně servisu.",
      },
      symes: {
        eyebrow: "SYMES · náš vlastní reportingový systém",
        title: "Online software, který zastřešuje celý servis.",
        lead:
          "SYMES je naše vlastní cloudová platforma pro řízení merchandisingových kampaní. Každá návštěva, každá položka, každá fotka — vše v jednom systému dostupném klientovi 24/7. Datový základ pro denní e-mail, QlikView analytiku i AI report.",
        standard: {
          eyebrow: "SYMES Online · Standardní report",
          h: "Detail návštěvy se vším, co klient potřebuje vědět.",
          caption: "Detail návštěvy v SYMES — Tesco / Budvar",
          items: [
            "TEXTOVÉ POLE — místo pro poznámku z prodejny",
            "PŘÍZNAK U POLOŽKY — OK · OOS · STOP · NELIST",
            "CENA",
            "DRUHOTNÉ UMÍSTĚNÍ — informace o DU na prodejně",
            "DOTAZNÍK — definuje klient (řešení s vedoucím, dostupnost POS …)",
            "FOTODOKUMENTACE — vč. GPS lokalizace",
          ],
        },
        promo: {
          eyebrow: "SYMES Online · Monitoring promo akcí",
          h: "Akce, které doopravdy probíhají na prodejně.",
          caption: "Promo modul — fotodokumentace druhotných umístění",
          items: [
            "Sledování promočních aktivit klienta",
            "Fotodokumentace druhotných umístění včetně online reportingu",
            "Okamžité řešení nerealizovaných aktivit / druhotných umístění",
          ],
        },
        qlik: {
          eyebrow: "QlikView · Analytická platforma",
          h: "Grafická analýza zdrojových dat ze SYMES.",
          caption: "QlikView dashboard — asociativní analytika",
          items: [
            "OOS dle EAN, OZ klienta, řetězce, prodejny",
            "Přehled opakovaných OOS, počet dnů ve stavu OOS",
            "Asociativní filtry — kombinujte parametry libovolně",
            "Výstupní formáty: PDF, Excel, live dashboard",
            "Živá licence, zaškolení a šablony programátorem v ceně servisu",
          ],
        },
        footer:
          "Všechny tři moduly — SYMES, e-mail summary i QlikView — jsou v ceně servisu. Žádné dodatečné licence, žádné další SaaS poplatky. Klient platí jednu měsíční fakturu za servis.",
      },

      kpis: {
        eyebrow: "KPI a vyhodnocování",
        title: "Měříme to, na čem záleží.",
        intro:
          "Nastavíme s vámi sadu klíčových ukazatelů, které budeme pravidelně sledovat a vyhodnocovat. Základem je distribuce, pokrytí a dostupnost.",
        items: [
          { h: "Audit listingu", t: "Aktualizovaný audit listingu podle jednotlivých prodejen v pravidelné frekvenci." },
          { h: "OOS analytika", t: "Analýzy OOS prostřednictvím QlikView — EAN, region, řetězec, prodejna." },
          { h: "Reporting návštěv", t: "Analýza počtu návštěv podle řetězců a lokalit, návrhy na změny počtu prodejen nebo frekvence." },
        ],
      },
      promo: {
        eyebrow: "Monitoring promo akcí",
        title: "Akce, které doopravdy probíhají na prodejně.",
        items: [
          "Sledování promočních aktivit klienta",
          "Fotodokumentace druhotných umístění včetně online reportingu",
          "Okamžité řešení nerealizovaných aktivit / druhotných umístění",
        ],
      },
      onboarding: {
        eyebrow: "Jak startujeme novou zakázku",
        title: "Rychlý start bez zbytečné byrokracie.",
        body: [
          "Spolupráce začíná nastavením startovacího seznamu prodejen a frekvence návštěv. Provedeme komplexní audit listingu na servisovaných prodejnách — analýzu centrálního listingu oproti dispozičnímu listu.",
          "Na základě auditu provedeme výběr domů, doporučíme frekvenci návštěv, nastavíme domy a listing v systému SYMES a připravíme reportingové šablony v QlikView přesně podle vašich potřeb.",
        ],
        promise: "Od prvního dne víte, co se děje. A od prvního týdne máte data.",
      },
      cta: {
        body: "Na základě auditu nastavíme domy a listing v systému SYMES a připravíme reportingové šablony v QlikView přesně podle vašich potřeb.",
      },
      finalCta: {
        eyebrow: "Pojďme se potkat",
        title: "Jste připraveni servisovat lépe ?",
        sub:
          "Připravíme nezávaznou nabídku přesně pro váš rozsah — řetězce, počet prodejen a frekvenci návštěv.",
        button: "Kontaktovat",
        email: "info@globalmarketing.cz",
      },
    },

    instore: {
      hero: {
        eyebrow: "Pilíř 02 / Instore Data",
        title: "Co nevidíte na prodejním místě, nemůžete řídit.",
        sub:
          "Víte, za kolik se váš produkt skutečně prodává? Zda stojí na správném místě police? Zda vůbec stojí na polici? A co dělá konkurence ve stejné chvíli ve stejné prodejně? InstoreData jsou odpovědi na tyto otázky — v reálném čase, z každé prodejny, přehledně.",
        leadIn:
          "Global Marketing provozuje vlastní systémy pro sběr, zpracování a reporting instore dat. Nepracujeme s odhady — pracujeme s fakty z terénu. A sledujeme nejen vaše produkty, ale také konkurenci — v kategorii, kterou nám zadáte.",
      },
      sections: {
        price: {
          eyebrow: "1 · Price Monitoring",
          title: "Víte, za kolik se váš produkt skutečně prodává? A za kolik ho prodává konkurence?",
          body: [
            "Skutečná cena může být na prodejně odlišná od doporučené maloobchodní ceny. Řetězce mění ceny, spouštějí akce, podstřelují cenové hladiny — a pokud to nesledujete v reálném čase, přicházíte o přehled i o kontrolu nad vlastním cenovým positioningem.",
            "Price monitoring je systematické sledování skutečných cen vašich produktů i konkurenčních značek na prodejnách v celé síti. Výsledkem není jen číslo — je to přehled o tom, kde jste, kde je konkurence a kde jsou příležitosti nebo rizika.",
          ],
          checklist: [
            "Skutečné prodejní ceny vašich produktů na jednotlivých prodejnách a řetězcích",
            "Srovnání s doporučenou maloobchodní cenou a odhalení cenových odchylek",
            "Ceny konkurenčních produktů ve stejné kategorii a na stejných prodejnách",
            "Akční a promoční ceny — kdy, kde a za kolik",
            "Typ ceny — běžná, akční nebo věrnostní",
            "Dlouhodobé cenové trendy a sezónní výkyvy",
          ],
          footer:
            "Pokud se váš produkt pravidelně nachází pod doporučenou cenou v klíčových řetězcích, poškozuje to váš brand positioning a ztěžuje vyjednávání s ostatními zákazníky. Pokud konkurence trvale podstřeluje vaše ceny, musíte o tom vědět dřív, než se to projeví na obratu.",
        },
        shelf: {
          eyebrow: "2 · Shelf Monitoring",
          title: "Obraz o stavu police je více než tisíc slov. Ale jen tehdy, pokud ho máte.",
          body: [
            "Shelf monitoring je systematické ověřování toho, jak váš produkt skutečně vypadá v místě prodeje. Zda je správně umístěn, odpovídá pozici v planogramu, je dostupný a cenový štítek je na správném místě se správnou cenou.",
            "Terénní realita se od sjednaných podmínek s řetězcem liší častěji, než by se zdálo. Produkt může být přesunut na horší pozici, chybět na sekundárním umístění nebo být přehlédnut při doplňování. Každý z těchto stavů vás stojí tržby — a bez shelf monitoringu o něm nevíte.",
          ],
          checklist: [
            "Audit umístění produktu na polici — pozice, výška, viditelnost",
            "Kontrola dodržování planogramu a šíře sortimentu",
            "Sledování dostupnosti produktu — přítomnost na polici, stav zásoby, OOS detekce",
            "Kontrola cenových štítků — správnost, čitelnost, umístění",
            "Audit sekundárních umístění — čela, displeje, promoční zóny",
            "Fotodokumentace stavu police pro každou navštívenou prodejnu",
          ],
          footer:
            "Jednorázová kontrola vám řekne, jak to vypadalo v jedné prodejně jeden den. Systematický shelf monitoring vám řekne, kde jsou chronické problémy, kteří merchandiseři plní standardy a kde jsou opakovaná selhání, která je potřeba řešit na úrovni řetězce nebo distribuce.",
        },
        secondary: {
          eyebrow: "Druhotná umístění",
          title: "Domluvili jste si druhotné umístění. Ale víte, zda skutečně funguje?",
          body: [
            "Druhotné umístění — čelo regálu, paleta v uličce, display u pokladny, promoční island — je jedním z nejúčinnějších nástrojů pro zvýšení viditelnosti produktu v místě prodeje. Stojí peníze, vyžaduje vyjednávání s řetězcem a často je součástí obchodních podmínek nebo JBP.",
            "Stejně důležité je mít přehled o tom, co se děje v celé kategorii — jaká druhotná umístění mají vaši konkurenti, jak velký prostor v prodejně zaujímají a kde se pohybují vůči vašim umístěním.",
          ],
          twoCol: [
            {
              title: "Vlastní druhotná umístění",
              text:
                "Systematicky ověřujeme přítomnost a stav všech sjednaných druhotných umístění — typ, lokalita v prodejně, počet facingů, stav zásoby a soulad se specifikací.",
            },
            {
              title: "Konkurenční druhotná umístění",
              text:
                "Na základě zadané kategorie monitorujeme veškerá druhotná umístění konkurenčních značek — typ, počet, stav zásoby, vzdálenost a viditelnost vůči vašim umístěním.",
            },
          ],
        },
        pos: {
          eyebrow: "4 · POS materiály",
          title: "Vaše kampaň běží. Ale komunikuje skutečně v místě prodeje?",
          body: [
            "POS materiály — stojany, shelf talkery, wobblery, plakáty, nálepky, displeje — jsou investicí do komunikace v rozhodujícím momentu. Zákazník stojí u police a rozhoduje. Pokud váš POS materiál chybí, je poškozený nebo zastaralý, ta investice přišla vniveč.",
          ],
          twoCol: [
            {
              title: "Vlastní POS materiály",
              text:
                "Přítomnost, stav a správnost umístění materiálů. Soulad s aktuální kampaní, časovým obdobím a promoční aktivitou.",
            },
            {
              title: "Konkurenční POS materiály",
              text:
                "Sledujeme materiály konkurence v kategorii, jejich umístění a vizuální výraznost — vstup pro trade marketing i vyjednávání s řetězci.",
            },
          ],
        },
        datapoints: {
          eyebrow: "Co sbíráme ke každé položce",
          title: "Datové body pro každý EAN.",
          intro:
            "Pro každý produkt — každý EAN — zaznamenáváme úplnou sadu datových bodů, která dává smysl nejen pro okamžitý přehled, ale i pro dlouhodobou analytiku a vyjednávání s řetězci.",
          groups: [
            {
              h: "Identifikace produktu",
              t: "EAN, název, dodavatel a výrobce, země původu, sortimentní kategorie a podskupina.",
            },
            {
              h: "Cenové údaje",
              t: "Aktuální prodejní cena, typ ceny — běžná, akční nebo věrnostní.",
            },
            {
              h: "Prezentace na polici",
              t: "Počet facingů, obsah produktu, měrná jednotka, typ obalu.",
            },
            {
              h: "Umístění a parametry",
              t: "Označení druhotného umístění, kalibrace, sortimentní podskupina.",
            },
          ],
        },
        mervik: {
          eyebrow: "MERVIK",
          title: "Mobilní aplikace pro terénní reporting.",
          body:
            "Naši merchandiseři pracují s aplikací MERVIK, která umožňuje online i offline reporting přímo z prodejny. Každá návštěva je zaznamenaná, každý problém zdokumentovaný — včetně fotografie. Klient má přístup k datům v reálném čase, může podávat reklamace online a sledovat jejich řešení.",
        },
        symes: {
          eyebrow: "SYMES",
          title: "Vlastní datový systém.",
          body:
            "Náš reportingový systém SYMES zpracovává data pořízená přes mobilní aplikaci MERVIK. Výstupy jsou dostupné v přehledech podle EAN, prodejny, řetězce, obchodní jednotky nebo merchandisera.",
          bullets: [
            "Přehled OOS výpadků podle EAN a zákazníka",
            "Opakované výpadky a počet dní v OOS statusu",
            "Audit plnění planogramu a cenových štítků",
            "Fotodokumentace promoakcí a in-store prezentace",
          ],
        },
        qlik: {
          eyebrow: "QlikView",
          title: "Analytická platforma světové třídy.",
          body: [
            "Data mají hodnotu jen tehdy, když jim rozumíte. Všechna instore data ze SYMES a MERVIK přenášíme do platformy QlikView — jednoho z nejpokročilejších analytických nástrojů na světě, vyvinutého švédskou společností Qlik.",
            "Klíčovou vlastností QlikView je asociativní model dat, který umožňuje procházet data volně ve všech směrech, nacházet souvislosti a odpovídat na otázky, které předem nikdo nepředpokládal.",
            "V prostředí QlikView sestavujeme pro každého klienta přehledné dashboardy: dostupnost produktů, vývoj OOS, plnění planogramu, cenové odchylky, stav druhotných umístění i přehled POS komunikace vlastní i konkurenční. Vše filtrováno podle řetězce, prodejny, regionu, značky nebo časového období.",
            "Žádné složité tabulky v Excelu. Žádné čekání na report. Data jsou k dispozici okamžitě, srozumitelně a připravená k prezentaci — ať už pro váš obchodní tým, nebo pro jednání s retailerem.",
          ],
        },
        why: {
          eyebrow: "Proč na tom záleží",
          title: "Nestačí vědět, kde jste vy. Musíte vědět, kde je konkurence.",
          body:
            "Dodavatel, který přichází na jednání s řetězcem s přesnými daty o dostupnosti, cenách, stavu police, druhotných umístěních i POS komunikaci — vlastní i konkurenční — argumentuje podloženými informacemi zcela jinak než dodavatel, který spoléhá na pocity nebo zpožděné reporty. Instore data z našich systémů, vizualizovaná v QlikView, vám tyto argumenty dávají k dispozici každý den.",
        },
        processIntro: {
          eyebrow: "Jak data zaznamenáváme a zpracováváme",
          title: "MERVIK · SYMES · QlikView — naše tři vrstvy.",
          sub: "Mobilní sběr v terénu, vlastní datová vrstva a světová analytická platforma — tři propojené nástroje, které z každé návštěvy dělají dashboard.",
        },
      },
      cta: {
        eyebrow: "Začněte u dat",
        title: "Chcete vidět vaše data v QlikView?",
        sub:
          "Připravíme ukázkový dashboard na vašich datech. Zdarma a bez závazků.",
      },
    },
    shelfmasters: {
      hero: {
        eyebrow: "Pilíř 03 / Shelfmasters",
        title: "Partnerství pro outsourcing retailové exekuce.",
        sub:
          "Zefektivnění maloobchodních operací pomocí specializovaných externích terénních týmů. Místo nákladného a nepružného interního obchodního týmu nasazujeme tým retail execution specialistů — s jednotnou metodikou, měřitelnými KPI a smluvně garantovanou kvalitou.",
        leadIn:
          "Strategické plánování a vyjednávání s odběrateli zůstává u vás. My přebíráme každodenní provedení v terénu — a děláme to o desítky procent levněji a měřitelně lépe.",
      },
      benefits: {
        eyebrow: "Proč Shelfmasters",
        title: "Čtyři hlavní přínosy outsourcingu retailové exekuce.",
        items: [
          { kicker: "01", h: "Snížené fixní náklady", t: "Nižší fixní mzdové náklady díky flexibilnímu modelu — platíte za výsledek, ne za úvazek." },
          { kicker: "02", h: "Zvýšená flexibilita", t: "Kapacita se přizpůsobí sezónním požadavkům a obchodním potřebám — bez náboru a propouštění." },
          { kicker: "03", h: "Jednotná kvalita", t: "Stejné standardy exekuce napříč všemi prodejnami a maloobchodními kanály." },
          { kicker: "04", h: "Kontrola výkonu", t: "Viditelnost v reálném čase a měřitelný dohled nad terénními operacemi." },
        ],
      },
      split: {
        eyebrow: "Rozdělení odpovědností",
        title: "Co děláme my, co si necháváte vy.",
        intro:
          "Tento projekt přebírá exekuci a každodenní výkon — nikoli strategická obchodní vyjednávání. Strategické funkce zůstávají pod vaší kontrolou.",
        gm: {
          h: "Global Marketing zajišťuje",
          items: [
            "Kontroly listingu a sortimentu",
            "Řízení dostupnosti zboží na regálech (OSA)",
            "Umístění produktů dle planogramů a plnění dohod s centrálami řetězců",
            "Realizace promo akcí",
            "Reporting a fotodokumentace z prodejen",
            "Komunikace s personálem prodejen a řešení nedostatků",
          ],
        },
        client: {
          h: "Klient si ponechává",
          items: [
            "Jednání s centrálami řetězců",
            "Cenovou strategii a politiku",
            "Roční rámcové dohody",
            "Plánování promo aktivit",
          ],
        },
      },
      ops: {
        eyebrow: "Provozní rámec",
        title: "Komunikace, reporting a výstupy pro klienta.",
        groups: [
          {
            h: "Komunikace",
            items: [
              "Pravidelné status meetingy s klíčovými stakeholdery",
              "Měsíční business review",
              "Jasná pravidla eskalace pro řešení problémů",
              "Přesné podmínky a definice SLA",
            ],
          },
          {
            h: "Reporting & datové systémy",
            items: [
              "Digitální reporting přes mobilní aplikaci",
              "Fotodokumentace z každé návštěvy prodejny",
              "Denní, týdenní a měsíční přehledy výkonnosti",
              "Identifikace a řešení problémů v reálném čase",
            ],
          },
          {
            h: "Výstupy pro klienta",
            items: [
              "Přehled plnění po řetězcích",
              "Analýza dle regionu a prodejen",
              "Akční doporučení pro zlepšení",
            ],
          },
        ],
      },
      phases: {
        eyebrow: "Plán implementace",
        title: "Třífázová implementace.",
        intro:
          "Strukturovaný přístup zajišťuje hladký přechod z interního na externí model exekuce.",
        items: [
          {
            n: "01",
            h: "Analýza a návrh",
            d: "Až 14 dní",
            list: [
              "Audit současného obchodního modelu klienta",
              "Identifikace činností pro převod vs. zachování u klienta",
              "Návrh optimálního modelu pokrytí",
            ],
          },
          {
            n: "02",
            h: "Pilotní program",
            d: "2–3 měsíce",
            list: [
              "Testování ve vybraných řetězcích a regionech",
              "Stanovení a kalibrace klíčových KPI",
              "Doladění procesů a struktury reportingu",
            ],
          },
          {
            n: "03",
            h: "Roll-out",
            d: "Progresivní",
            list: [
              "Postupné nasazení ve všech regionech, řetězcích a prodejnách",
              "Úplná náhrada interních týmů",
              "Úplné předání provozu",
            ],
          },
        ],
      },
      models: {
        eyebrow: "FTE vs. SLA",
        title: "Dva přístupy k terénním operacím.",
        intro:
          "Pochopení zásadního rozdílu mezi tradičním obsazením pozic a SLA modelem outsourcingu pokrytí.",
        fte: {
          h: "FTE model — interní zaměstnanci",
          rows: [
            ["Nákladová struktura", "Platba za lidi a jejich platy"],
            ["Fixní náklady", "Předvídatelné, ale nepružné výdaje"],
            ["Řízení", "Přímý dohled nad jednotlivci"],
            ["Hodnocení", "Subjektivní posouzení úsilí"],
            ["Odpovědnost", "Obtížné vynucování sankcí"],
            ["Škálovatelnost", "Náročná úprava kapacity"],
          ],
          tone: "tradiční model",
        },
        sla: {
          h: "SLA model — outsourcing pokrytí",
          rows: [
            ["Nákladová struktura", "Platba za dodané služby"],
            ["Variabilní náklady", "Sladěné s aktuálními potřebami"],
            ["Řízení", "Zaměření na výsledky a výstupy"],
            ["Hodnocení", "Objektivní měření dodávek"],
            ["Odpovědnost", "Smluvní pokuty a sankce"],
            ["Škálovatelnost", "Flexibilní úprava rozsahu"],
          ],
          tone: "doporučený přístup",
        },
        slaDef:
          "SLA definuje: jaké výsledky musí být dodány, v jaké kvalitě, jak často a jaké jsou důsledky nedodržení. Mění retailovou exekuci z personální výzvy na řízenou službu se zaručenými výsledky.",
      },
      kpis: {
        eyebrow: "SLA — indikátory výkonu",
        title: "Co měříme a jak často.",
        cols: ["#", "Oblast výkonu", "Metrika SLA", "Metoda měření", "Frekvence"],
        rows: [
          ["1", "Dostupnost produktu", "On-Shelf-Availability (OSA)", "Foto + reporting", "Při každé návštěvě"],
          ["2", "Promo exekuce", "Promo compliance", "Foto + checklist", "Den zahájení akce + průběžně"],
          ["3", "Planogram", "Planogram compliance", "Audit fotografií", "Měsíčně"],
          ["4", "Coverage", "Plnění plánu návštěv", "GPS / log návštěv", "Měsíčně"],
          ["5", "Reporting", "Včasnost reportingu", "Systémový log", "Při každé návštěvě"],
          ["6", "Kvalita exekuce", "Kvalita vystavení", "Audit", "Měsíčně"],
          ["7", "Provozní problém", "Doba odezvy na řešení", "Podaná reklamace", "Průběžně"],
        ],
      },
      reversibility: {
        eyebrow: "Reverzibilita",
        title: "Žádný lock-in. Žádná nevratná investice.",
        items: [
          { h: "Nízkonákladové vrácení", t: "Návrat k původnímu modelu bez vysokých nákladů nebo nevratných škod." },
          { h: "Snadné ukončení", t: "Externí tým může být ukončen s odpovídající výpovědní lhůtou." },
          { h: "Žádná závislost", t: "Zabraňuje závislosti na jednom konkrétním řešení nebo poskytovateli." },
          { h: "Interní know-how zůstává", t: "Kritické procesy a operační know-how zůstávají v rámci organizace klienta." },
        ],
      },
      economics: {
        eyebrow: "Ekonomika projektu",
        title: "Konkrétní čísla. Konkrétní úspora.",
        intro: "Příklad: 10 obchodních zástupců, 2 000 návštěv měsíčně.",
        fteCost: {
          h: "Náklady na 1 FTE (měsíčně)",
          items: [
            ["Čistá mzda", "45 000 Kč"],
            ["Hrubá mzda (odhad)", "61 000 Kč"],
            ["Odvody zaměstnavatele (33,8 %)", "~21 000 Kč"],
            ["Mzdové náklady celkem", "82 000 Kč"],
            ["Operativní leasing auta", "13 000 Kč"],
            ["Palivo (4 000 km)", "8 400 Kč"],
            ["Ostatní náklady na auto", "2 500 Kč"],
          ],
          total: "≈ 106 000 Kč / měsíc",
          footnote:
            "Nezahrnuje: manažerský dohled, nábor a zaškolení, fluktuaci, nemocenskou a dovolenou, IT vybavení, mobilní telefon, benefity.",
        },
        compare: {
          h: "Cena za 1 návštěvu",
          fte: { label: "FTE", value: "530 Kč", sub: "10 návštěv/den, 200/měsíc" },
          sla: { label: "SLA", value: "180 Kč", sub: "outsourcing" },
          delta: "−66 %",
          deltaLabel: "úspora na návštěvu",
        },
        big: {
          eyebrow: "2 000 návštěv měsíčně",
          fte: { label: "Interní tým / 10× FTE", value: "1 060 000 Kč" },
          sla: { label: "SLA model", value: "360 000 Kč" },
          monthly: { label: "Úspora měsíčně", value: "700 000 Kč" },
          yearly: { label: "Roční úspora", value: "8 400 000 Kč" },
          claim: "SLA model převádí fixní náklady na variabilní — roční úspora 66 % oproti FTE modelu.",
        },
      },
      cta: {
        eyebrow: "Pojďme spočítat váš case",
        title: "Kolik vás stojí současný model? Spočítáme to společně.",
        sub:
          "Pošleme vám nezávazný odhad úspory pro váš konkrétní rozsah — řetězce, počet prodejen, frekvence návštěv. Reálná čísla, žádné prezentace.",
        contact: {
          name: "Petr Bařina",
          email: "barina@globalmarketing.cz",
          phone: "+420 602 11 11 08",
          company: "Global Marketing s.r.o.",
        },
      },
    },

    form: {
      title: "Chcete vědět víc? Ozvěte se nám.",
      name: "Jméno a příjmení",
      email: "Pracovní e-mail",
      company: "Společnost",
      phone: "Telefon",
      message: "O co máte zájem? (volitelné)",
      submit: "Odeslat zprávu",
      submitting: "Odesílám…",
      successTitle: "Odesláno",
      success: "Děkujeme. Ozveme se do 24 hodin.",
      error: "Něco se nepovedlo, zkuste to prosím znovu.",
      requiredName: "Vyplňte prosím jméno",
      requiredEmail: "Vyplňte prosím platný e-mail",
    },
    comingSoon: {
      title: "Stránka se připravuje.",
      sub: "Tato služba bude k dispozici brzy. Mezitím prozkoumejte sekci Instore Data nebo nás kontaktujte.",
      cta: "Přejít na Instore Data",
    },
    footer: {
      tagline: "Future of retail intelligence.",
      copy: "© Global Marketing. Všechna práva vyhrazena.",
    },
    admin: {
      title: "Admin · Leady",
      tokenLabel: "Admin token",
      login: "Přihlásit",
      logout: "Odhlásit",
      empty: "Zatím žádné poptávky.",
      total: "Celkem",
      delete: "Smazat",
      confirmDelete: "Opravdu smazat tento záznam?",
    },
  },
  en: {
    nav: {
      home: "Home",
      pillars: "Solutions",
      instore: "InStore Data",
      admin: "Admin",
      contact: "Contact",
      about: "About",
    },
    common: {
      learnMore: "Learn more",
      comingSoon: "Coming soon",
      backHome: "Back home",
      czech: "CZ",
      slovak: "SK",
      english: "EN",
    },
    home: {
      eyebrow: "Future of retail",
      heroTitle: "Real data from the field. Real leverage at the table.",
      heroSub:
        "Global Marketing operates proprietary systems for collecting and analysing instore data. We don't work with estimates — we work with facts from the field.",
      heroCta1: "Explore InStore Data",
      heroCta2: "Our solutions",
      headerCta: "Explore our solutions",
      pillarsEyebrow: "6 Pillars",
      pillarsTitle: "The architecture of modern merchandising.",
      pillarsSub:
        "Six interconnected disciplines that help brands decide on data — not impressions.",
      stats: [
        { k: "1,200+", v: "monitored stores" },
        { k: "40M+", v: "datapoints / year" },
        { k: "99.2%", v: "report uptime" },
        { k: "24 h", v: "audit to dashboard" },
      ],
      ctaTitle: "Ready for the next step?",
      ctaSub:
        "Let's talk about your category, stores and campaigns. No strings attached.",
      ctaButton: "Contact us",
    },
    pillars: {
      merchandising: {
        title: "Merchandising Services",
        kicker: "01",
        desc: "Full-scope merchandising across CZ and SK. MERVIK + SYMES + AI report. Same-day issue resolution.",
      },
      instore: {
        title: "InStore Data",
        kicker: "02",
        desc: "Price & shelf monitoring in real time. SYMES + QlikView. Facts over impressions.",
      },
      shelfmasters: {
        title: "Shelfmasters",
        kicker: "03",
        desc: "Outsourced retail execution. SLA over FTE — −66% cost, measurable KPIs, no lock-in.",
      },
      digital: {
        title: "RetailStore Digitalisation",
        kicker: "04",
        desc: "Store digitalisation — from ESL through IoT sensors to in-store behavioural analytics.",
      },
      consulting: {
        title: "Retail Consulting",
        kicker: "05",
        desc: "Go-to-Market, chain negotiation, JBP, sales org and in-store data. 28+ years of practice.",
      },
      pos: {
        title: "POS",
        kicker: "06",
        desc: "Production, warehouse, distribution and installation of POS. POS E-shop for sales teams. Promokalendar for retailers.",
      },
    },
    merchandising: {
      hero: {
        eyebrow: "Pillar 01 / Merchandising",
        title: "Your products in the right place. Always.",
        sub:
          "Merchandising is the foundation of any successful retail presence. Getting product on shelf isn't enough — it must be there in the right quantity, in the right place, in line with the planogram and the agreed terms. Every day, in every store.",
        leadIn:
          "Global Marketing delivers full-scope merchandising services across the Czech Republic and Slovakia. We cover all major chains and the independent market — with our own team, systems and reporting.",
      },
      process: {
        eyebrow: "How merchandising works",
        title: "Field, management and data in a single system.",
        intro:
          "Every visit is managed, documented and evaluated. Each service visit runs in five steps.",
        steps: [
          { n: "01", h: "Visit briefing", t: "Full assignment delivered straight into the MERVIK mobile app." },
          { n: "02", h: "Surface check", t: "Shelf state, planogram, promo zones and price tags." },
          { n: "03", h: "Replenishment", t: "Product replenishment across primary and secondary placements." },
          { n: "04", h: "Reporting", t: "Structured report and photo documentation from the store floor." },
          { n: "05", h: "Sync", t: "Data is pushed instantly into the SYMES reporting system." },
        ],
        outro: "Results are available immediately — no waiting, no manual reporting.",
      },
      team: {
        eyebrow: "Our team",
        title: "You know who services your stores. And why it matters.",
        intro: "Behind every project sits a dedicated team with clearly defined roles and responsibilities.",
        roles: [
          {
            h: "Key Account Manager",
            kicker: "Main contact",
            items: [
              "Primary contact for the client",
              "Owns the project, communicates with the client's commercial team",
              "Translates requirements into execution and is accountable for results",
            ],
          },
          {
            h: "Regional managers",
            kicker: "Field leadership",
            items: [
              "Lead the merchandiser field team",
              "Run training, replacements, control activities",
              "Direct line to the client's commercial team",
            ],
          },
          {
            h: "SYMES team",
            kicker: "Data & reporting",
            items: [
              "Defines the shape and frequency of reporting outputs",
              "Manages listings and runs photo campaigns",
              "Audits data quality",
            ],
          },
        ],
      },
      quality: {
        eyebrow: "Quality control",
        title: "Every visit is documented. Every issue gets fixed.",
        body: [
          "Regional managers run regular control visits based on a pre-defined monthly plan. Photo documentation is captured online directly from the mobile app — no photo, no closed visit. Client ride-along audits are also available.",
          "When an issue arises, we fix it the same day. You log a complaint online directly into SYMES — and we respond immediately. Replacement visit, merchandiser swap, manager escalation. No 'next week'.",
        ],
        callouts: [
          { k: "100%", t: "visits with mandatory online photo proof" },
          { k: "Same-day", t: "issue resolution via SYMES" },
          { k: "Ride-along", t: "client field audits" },
        ],
      },
      reporting: {
        eyebrow: "Reporting & data",
        title: "You know what's happening in every store. In real time.",
        intro:
          "All visit data is instantly available in the reporting systems — in four formats.",
        items: [
          {
            n: "01",
            tag: "SYMES Online",
            h: "Comprehensive online overview 24/7",
            body:
              "Unlimited access to full visit data with Excel export and photo evidence — anytime, anywhere.",
            list: [
              "Item flag: OK · OOS · STOP · NOT LISTED · LOW STOCK",
              "Price and price type — base, promo or loyalty",
              "Secondary placements (DU) on the shop floor",
              "Expiring shelf life — at-risk products",
              "Client-defined questionnaire (OOS, POS materials)",
              "Free-text note field",
              "Photo documentation of every visit",
            ],
          },
          {
            n: "02",
            tag: "Email Summary",
            h: "Daily 6 a.m. e-mail digest",
            body:
              "Excel summary of the previous day, sent at 6 a.m. to your defined addresses — OOS, prices, listing checks and additional parameters per your spec.",
          },
          {
            n: "03",
            tag: "QlikView",
            h: "World-class graphical analytics",
            body:
              "Associative analytics — OOS by EAN, rep, region, chain or store. Recurring OOS and their duration. Output as PDF or live licence.",
          },
          {
            n: "04",
            tag: "AI Report · NEW",
            h: "AI analysis of in-store photos",
            body:
              "Brand new: AI report. Data extracted directly from in-store photos — every shelf item, price tag, promo flag and shelf fill rate. Output as PDF.",
          },
        ],
        footer:
          "Client onboarding and reporting template setup by our developer are included in the service.",
      },
      symes: {
        eyebrow: "SYMES · our proprietary reporting system",
        title: "The online software that holds the whole service together.",
        lead:
          "SYMES is our own cloud platform for managing merchandising campaigns. Every visit, every SKU, every photo — all in one system available to the client 24/7. It's the data base for the daily e-mail, QlikView analytics and the AI report.",
        standard: {
          eyebrow: "SYMES Online · Standard report",
          h: "Visit detail with everything the client needs to know.",
          caption: "Visit detail in SYMES — Tesco / Budvar",
          items: [
            "TEXT FIELD — free-text note from the store",
            "ITEM FLAG — OK · OOS · STOP · NELIST · LOW-STOCK",
            "PRICE & TYPE — for the client's TOP 10 SKUs",
            "SECONDARY PLACEMENT — info on in-store DU",
            "EXPIRY ALERT — products with shortening shelf life",
            "ORDER PROPOSAL — handover to the responsible person",
            "QUESTIONNAIRE — defined by client (e.g. POS readiness)",
            "MANAGER CONTACT — when, who, what",
            "PHOTO DOCUMENTATION — incl. GPS location",
          ],
        },
        promo: {
          eyebrow: "SYMES Online · Promo monitoring",
          h: "Promotions that actually run on the floor.",
          caption: "Promo module — photo proof of secondary placements",
          items: [
            "Tracking client's promotional activities on visit day (and beyond)",
            "Photo documentation of secondary placements with online reporting within 24 hours",
            "Same-day resolution of unrealised activities / placements",
          ],
        },
        qlik: {
          eyebrow: "QlikView · Analytics platform",
          h: "Graphical analytics of the SYMES data source.",
          caption: "QlikView dashboard — associative analytics",
          items: [
            "OOS by EAN, sales rep, chain, store",
            "Repeat OOS overview, days-in-OOS count",
            "Associative filters — combine any dimensions",
            "Export formats: PDF, Excel, live dashboard",
            "Active license, onboarding and templates by our dev — included in the service",
          ],
        },
        footer:
          "All three modules — SYMES, e-mail summary and QlikView — are included in the service. No add-on licenses, no extra SaaS. One monthly invoice for the whole service.",
      },

      kpis: {
        eyebrow: "KPIs & evaluation",
        title: "We measure what matters.",
        intro:
          "We agree a set of key indicators with you and track them on a defined cadence. The core: distribution, coverage and availability.",
        items: [
          { h: "Listing audit", t: "Updated listing audit per store on a regular cadence." },
          { h: "OOS analytics", t: "OOS analyses via QlikView — EAN, region, chain, store." },
          { h: "Visits reporting", t: "Visit volume by chain and location; recommendations on store count and visit frequency." },
        ],
      },
      promo: {
        eyebrow: "Promo monitoring",
        title: "Promotions that actually run on the floor.",
        items: [
          "Tracking the client's promotional activities",
          "Photo documentation of secondary placements with online reporting",
          "Same-day resolution of unrealised activities / placements",
        ],
      },
      onboarding: {
        eyebrow: "How we kick off a new project",
        title: "A fast start without unnecessary bureaucracy.",
        body: [
          "Cooperation starts with the initial store list and visit frequency setup. We run a comprehensive listing audit across the serviced stores — comparing central listing against the dispozition list.",
          "Based on the audit we shortlist stores, recommend visit frequency, set up stores and listings in SYMES and prepare QlikView reporting templates exactly to your specification.",
        ],
        promise: "From day one you know what's happening. From week one you have the data.",
      },
      cta: {
        body: "Based on the audit we set up stores and listings in SYMES and prepare QlikView reporting templates exactly to your specification.",
      },
      finalCta: {
        eyebrow: "Let's meet",
        title: "Ready to service better?",
        sub:
          "We'll prepare a non-binding proposal for your exact scope — chains, store count and visit frequency.",
        button: "Get in touch",
        email: "info@globalmarketing.cz",
      },
    },

    instore: {
      hero: {
        eyebrow: "Pillar 02 / InStore Data",
        title: "What you don't see at the point of sale, you can't manage.",
        sub:
          "Do you know what your product really sells for? Whether it sits in the right shelf position? Whether it sits on the shelf at all? And what your competitor is doing in that same store at the same moment? InStore data answers these questions — in real time, from every store, clearly.",
        leadIn:
          "Global Marketing operates proprietary systems for the collection, processing and reporting of instore data. We don't work with estimates — we work with field facts. And we monitor not only your products, but also your competitors — in any category you give us.",
      },
      sections: {
        price: {
          eyebrow: "Price Monitoring",
          title: "Do you know what your product really sells for? And what your competitor charges?",
          body: [
            "The recommended retail price is one thing. The actual shelf price can be entirely different. Chains shift prices, run promos, undercut price tiers — and if you don't track it in real time, you lose visibility and control over your own price positioning.",
            "Price monitoring is the systematic tracking of real prices for your products and competing brands across the network. The output isn't just a number — it's a picture of where you are, where competition stands, and where opportunity or risk hides.",
          ],
          checklist: [
            "Real shelf prices for your products in individual stores and chains",
            "Comparison against RRP and detection of price deviations",
            "Competitor prices in the same category in the same stores",
            "Promo and discount prices — when, where and at what level",
            "Price type — base, promo or loyalty",
            "Long-term price trends and seasonal swings",
          ],
          footer:
            "If your product routinely flies below RRP in key chains, it damages brand positioning and weakens negotiations with other customers. If a competitor consistently undercuts you, you must know before it shows up in revenue.",
        },
        shelf: {
          eyebrow: "Shelf Monitoring",
          title: "A picture of the shelf is worth a thousand words. But only if you have one.",
          body: [
            "Shelf monitoring is the systematic verification of how your product actually appears at point of sale. Whether placed correctly, in line with the planogram, available, and with a correct, legible price tag.",
            "Field reality differs from agreed terms more often than you'd expect. Product gets relocated, missing from secondary placements, or skipped during replenishment. Each of those costs revenue — and without monitoring you don't know.",
          ],
          checklist: [
            "Audit of product placement — position, height, visibility",
            "Planogram and assortment width compliance",
            "Availability tracking — on shelf, stock state, OOS detection",
            "Price tag check — correctness, legibility, placement",
            "Audit of secondary placements — endcaps, displays, promo zones",
            "Photo documentation for every visited store",
          ],
          footer:
            "A one-shot check tells you what one store looked like one day. Systematic shelf monitoring tells you where chronic issues sit, which merchandisers meet standards and where repeated failures need to be addressed at chain or distribution level.",
        },
        secondary: {
          eyebrow: "Secondary placements",
          title: "You agreed a secondary placement. But is it actually working?",
          body: [
            "Secondary placement — endcap, aisle pallet, checkout display, promo island — is one of the most effective tools to lift product visibility at point of sale. It costs money, requires negotiation with the chain and is often part of trade terms or JBP.",
            "Equally important is visibility into the whole category — what secondary placements competitors run, how much store space they take, and how they sit relative to yours.",
          ],
          twoCol: [
            {
              title: "Own placements",
              text:
                "We systematically verify the presence and condition of all agreed secondary placements — type, location, facing count, stock state and spec compliance.",
            },
            {
              title: "Competitor placements",
              text:
                "For the assigned category we track all competitor secondary placements — type, count, stock, distance and visibility versus yours.",
            },
          ],
        },
        pos: {
          eyebrow: "POS materials",
          title: "Your campaign is live. But does it really speak in-store?",
          body: [
            "POS materials — stands, shelf talkers, wobblers, posters, stickers, displays — are an investment in communication at the moment of decision. The shopper stands at the shelf and chooses. If your POS is missing, damaged or outdated, the investment is wasted.",
          ],
          twoCol: [
            {
              title: "Own POS",
              text:
                "Presence, condition and placement correctness. Alignment with the active campaign, time period and promotional activity.",
            },
            {
              title: "Competitor POS",
              text:
                "We track competitor POS in the category — placement and visual saliency. Input for trade marketing and exclusivity negotiations.",
            },
          ],
        },
        datapoints: {
          eyebrow: "Data points",
          title: "What we capture for every item.",
          intro:
            "For every product — every EAN — we record the full set of data points that powers both immediate visibility and long-term analytics or chain negotiations.",
          groups: [
            {
              h: "Product identity",
              t: "EAN, name, supplier and manufacturer, country of origin, assortment category and subgroup.",
            },
            {
              h: "Pricing",
              t: "Current shelf price, price type — base, promo or loyalty.",
            },
            {
              h: "Shelf presence",
              t: "Facing count, content, unit of measure, packaging type.",
            },
            {
              h: "Placement & params",
              t: "Secondary placement flag, calibration, assortment subgroup.",
            },
          ],
        },
        mervik: {
          eyebrow: "MERVIK",
          title: "Mobile app for field reporting.",
          body:
            "Our merchandisers run on MERVIK, which enables online and offline reporting directly from the store. Every visit is logged, every issue documented — with photo evidence. Clients access data in real time and can raise and track issues online.",
        },
        symes: {
          eyebrow: "SYMES",
          title: "Our proprietary data system.",
          body:
            "SYMES processes data from retailer feeds and field audits. Outputs available by EAN, store, chain, sales unit or merchandiser.",
          bullets: [
            "OOS overview by EAN and customer",
            "Recurring outages and days in OOS status",
            "Planogram and price tag compliance audit",
            "Photo documentation of promo and in-store activations",
          ],
        },
        qlik: {
          eyebrow: "QlikView",
          title: "World-class analytics platform.",
          body: [
            "Data has value only if you understand it. All instore data from SYMES and MERVIK is piped into QlikView — one of the most advanced analytics tools in the world, developed by the Swedish company Qlik.",
            "QlikView's defining capability is its associative data model — letting you traverse data freely in every direction and answer questions nobody anticipated upfront.",
            "Inside QlikView we craft per-client dashboards: availability, OOS evolution, planogram compliance, price deviations, secondary placements and POS communication — own and competitor. Filter by chain, store, region, brand or period.",
            "No tangled Excel sheets. No waiting on reports. Data ready instantly, legibly and presentation-ready — for your sales team or a retailer meeting.",
          ],
        },
        why: {
          eyebrow: "Why it matters",
          title: "Knowing where you stand isn't enough. You must know where competition is.",
          body:
            "A supplier walking into a chain meeting with precise data on availability, prices, shelf state, secondary placements and POS — own and competitor — argues with backed evidence in an entirely different way than a supplier relying on gut or delayed reports. InStore data from our systems, visualised in QlikView, gives you that argument every day.",
        },
        processIntro: {
          eyebrow: "How we capture and process data",
          title: "MERVIK · SYMES · QlikView — our three layers.",
          sub: "Mobile field capture, our own data layer and a world-class analytics platform — three interconnected tools that turn every visit into a dashboard.",
        },
      },
      cta: {
        eyebrow: "Start with the data",
        title: "Want to see your data in QlikView?",
        sub: "We'll prepare a sample dashboard on your own data. Free, no strings attached.",
      },
    },
    shelfmasters: {
      hero: {
        eyebrow: "Pillar 03 / Shelfmasters",
        title: "A partnership for outsourced retail execution.",
        sub:
          "Streamlining retail operations through a specialised external field team. Instead of an expensive, inflexible in-house sales force, we deploy a team of retail execution specialists — unified methodology, measurable KPIs, contractually guaranteed quality.",
        leadIn:
          "Strategic planning and chain negotiations stay with you. We take over daily field execution — and we do it tens of percent cheaper and measurably better.",
      },
      benefits: {
        eyebrow: "Why Shelfmasters",
        title: "Four key benefits of outsourced retail execution.",
        items: [
          { kicker: "01", h: "Lower fixed cost", t: "Lower fixed payroll thanks to a flexible model — you pay for outcomes, not headcount." },
          { kicker: "02", h: "Higher flexibility", t: "Capacity flexes with seasonality and business needs — no hire/fire cycles." },
          { kicker: "03", h: "Unified quality", t: "The same execution standards across all stores and retail channels." },
          { kicker: "04", h: "Performance control", t: "Real-time visibility and measurable oversight of field operations." },
        ],
      },
      split: {
        eyebrow: "Responsibility split",
        title: "What we do — and what stays with you.",
        intro:
          "This project takes over execution and day-to-day performance — not strategic commercial negotiations. Strategic functions stay under your control.",
        gm: {
          h: "Global Marketing handles",
          items: [
            "Listing and assortment checks",
            "On-shelf availability (OSA) management",
            "Product placement per planogram and HQ agreements",
            "Promotion execution",
            "Reporting and photo documentation from stores",
            "Communication with store staff and issue resolution",
          ],
        },
        client: {
          h: "Client retains",
          items: [
            "Negotiations with chain HQs",
            "Pricing strategy and policy",
            "Annual framework agreements",
            "Promotion planning",
          ],
        },
      },
      ops: {
        eyebrow: "Operational framework",
        title: "Communication, reporting and client outputs.",
        groups: [
          {
            h: "Communication",
            items: [
              "Regular status meetings with key stakeholders",
              "Monthly business review",
              "Clear escalation rules",
              "Defined SLA terms",
            ],
          },
          {
            h: "Reporting & data",
            items: [
              "Digital reporting via mobile app",
              "Photo documentation from every visit",
              "Daily, weekly and monthly performance reviews",
              "Real-time issue identification and resolution",
            ],
          },
          {
            h: "Client outputs",
            items: [
              "Compliance overview by chain",
              "Region and store-level analysis",
              "Actionable improvement recommendations",
            ],
          },
        ],
      },
      phases: {
        eyebrow: "Implementation plan",
        title: "Three-phase implementation.",
        intro:
          "A structured approach ensures a smooth transition from in-house to outsourced execution.",
        items: [
          { n: "01", h: "Analysis & design", d: "Up to 14 days", list: ["Audit of current sales model","Identification of activities to transfer vs. retain","Design of optimal coverage model"] },
          { n: "02", h: "Pilot programme", d: "2–3 months", list: ["Test in selected chains and regions","KPI definition and calibration","Process and reporting fine-tuning"] },
          { n: "03", h: "Roll-out", d: "Progressive", list: ["Gradual deployment across regions, chains and stores","Full replacement of in-house teams","Complete operational handover"] },
        ],
      },
      models: {
        eyebrow: "FTE vs. SLA",
        title: "Two approaches to field operations.",
        intro:
          "Understanding the fundamental difference between traditional headcount and an SLA outsourcing model.",
        fte: {
          h: "FTE — in-house headcount",
          rows: [
            ["Cost structure", "Pay for people and salaries"],
            ["Fixed cost", "Predictable but inflexible"],
            ["Management", "Direct supervision of individuals"],
            ["Evaluation", "Subjective effort assessment"],
            ["Accountability", "Hard to enforce penalties"],
            ["Scalability", "Capacity changes are hard"],
          ],
          tone: "traditional",
        },
        sla: {
          h: "SLA — outsourced coverage",
          rows: [
            ["Cost structure", "Pay for delivered services"],
            ["Variable cost", "Aligned with actual needs"],
            ["Management", "Outcome and output focus"],
            ["Evaluation", "Objective deliverable measurement"],
            ["Accountability", "Contractual penalties"],
            ["Scalability", "Flexible scope adjustment"],
          ],
          tone: "recommended",
        },
        slaDef:
          "An SLA defines: which outcomes must be delivered, in what quality, how often, and what happens if they aren't. It turns retail execution from a people problem into a managed service with guaranteed results.",
      },
      kpis: {
        eyebrow: "SLA — performance indicators",
        title: "What we measure and how often.",
        cols: ["#", "Service area", "SLA metric", "Method", "Frequency"],
        rows: [
          ["1", "Product availability", "On-Shelf-Availability (OSA)", "Photo + report", "Every visit"],
          ["2", "Promo execution", "Promo compliance", "Photo + checklist", "Launch day + ongoing"],
          ["3", "Planogram", "Planogram compliance", "Photo audit", "Monthly"],
          ["4", "Coverage", "Visit plan execution", "GPS / visit log", "Monthly"],
          ["5", "Reporting", "Reporting timeliness", "System log", "Every visit"],
          ["6", "Execution quality", "Display quality", "Audit", "Monthly"],
          ["7", "Operational issue", "Issue response time", "Filed claim", "Continuous"],
        ],
      },
      reversibility: {
        eyebrow: "Reversibility",
        title: "No lock-in. No irreversible investment.",
        items: [
          { h: "Low-cost reversal", t: "Return to the original model without high cost or sunk damage." },
          { h: "Easy termination", t: "External team can be ended with a reasonable notice period." },
          { h: "No vendor dependency", t: "Avoids dependency on a single solution or supplier." },
          { h: "Internal know-how stays", t: "Critical processes and operational know-how remain in your organisation." },
        ],
      },
      economics: {
        eyebrow: "Project economics",
        title: "Concrete numbers. Concrete savings.",
        intro: "Example: 10 sales reps, 2,000 visits per month.",
        fteCost: {
          h: "Cost per FTE (monthly)",
          items: [
            ["Net salary", "45,000 CZK"],
            ["Gross salary (est.)", "61,000 CZK"],
            ["Employer contributions (33.8%)", "~21,000 CZK"],
            ["Total payroll", "82,000 CZK"],
            ["Operational car lease", "13,000 CZK"],
            ["Fuel (4,000 km)", "8,400 CZK"],
            ["Other car costs", "2,500 CZK"],
          ],
          total: "≈ 106,000 CZK / month",
          footnote:
            "Excludes: management oversight, hiring & onboarding, churn, sick leave & holidays, IT equipment, phone, benefits.",
        },
        compare: {
          h: "Cost per visit",
          fte: { label: "FTE", value: "530 CZK", sub: "10 visits/day, 200/month" },
          sla: { label: "SLA", value: "180 CZK", sub: "outsourced" },
          delta: "−66%",
          deltaLabel: "saving per visit",
        },
        big: {
          eyebrow: "2,000 visits per month",
          fte: { label: "In-house team / 10× FTE", value: "1,060,000 CZK" },
          sla: { label: "SLA model", value: "360,000 CZK" },
          monthly: { label: "Monthly saving", value: "700,000 CZK" },
          yearly: { label: "Yearly saving", value: "8,400,000 CZK" },
          claim: "The SLA model converts fixed cost into variable — a 66% annual saving compared to the FTE model.",
        },
      },
      cta: {
        eyebrow: "Let's run the numbers on your case",
        title: "How much is your current model costing you? Let's calculate together.",
        sub:
          "We'll send you a non-binding savings estimate for your specific scope — chains, store count, visit frequency. Real numbers, no slideware.",
        contact: {
          name: "Petr Bařina",
          email: "barina@globalmarketing.cz",
          phone: "+420 602 11 11 08",
          company: "Global Marketing s.r.o.",
        },
      },
    },

    form: {
      title: "Request a sample dashboard",
      name: "Full name",
      email: "Work e-mail",
      company: "Company",
      phone: "Phone",
      message: "About your category (optional)",
      submit: "Submit request",
      submitting: "Sending…",
      successTitle: "Submitted",
      success: "Thank you. We'll be in touch within 24 hours.",
      error: "Something went wrong, please try again.",
      requiredName: "Please fill in your name",
      requiredEmail: "Please provide a valid e-mail",
    },
    comingSoon: {
      title: "This page is in preparation.",
      sub: "This service will be available soon. In the meantime, explore InStore Data or get in touch.",
      cta: "Go to InStore Data",
    },
    footer: {
      tagline: "Future of retail intelligence.",
      copy: "© Global Marketing. All rights reserved.",
    },
    admin: {
      title: "Admin · Leads",
      tokenLabel: "Admin token",
      login: "Sign in",
      logout: "Sign out",
      empty: "No leads yet.",
      total: "Total",
      delete: "Delete",
      confirmDelete: "Really delete this record?",
    },
  },
  sk: skTranslations,
};
